import { useInView } from '@/hooks/useInView';

const reasons = [
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/advantages_1.svg', text: 'To learn at their own pace, in their own way' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/advantages_2.svg', text: 'To stay engaged instead of feeling left out' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/principles_3.svg', text: 'To get equal opportunities for future careers' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/advantages_4.svg', text: 'To build confidence by creating real results' },
];

export default function StatsSection() {
  const { ref, inView } = useInView();

  return (
    <section id="about" ref={ref as React.RefObject<HTMLElement>} className="bg-white py-24 px-6">
      <div className="max-w-5xl mx-auto">
        {/* Stat block */}
        <div className={`flex flex-col md:flex-row items-center gap-8 mb-20 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex-shrink-0 w-40 h-40 rounded-full bg-yellow-400 flex flex-col items-center justify-center">
            <span className="text-5xl font-extrabold text-gray-900 font-syne">25%</span>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3 font-syne">
              children with special educational needs lack access to STEM education
            </h2>
            <p className="text-gray-500 text-base">
              The reason is a shortage of inclusive STEM kits and specially trained educators
            </p>
          </div>
        </div>

        {/* Why section */}
        <div id="why">
          <h2 className={`text-3xl md:text-4xl font-extrabold text-gray-900 mb-12 font-syne text-center transition-all duration-700 delay-100 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            Why should STEM kits be adapted for children with special educational needs?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {reasons.map((r, i) => (
              <div
                key={r.text}
                className={`group flex flex-col items-center text-center gap-4 p-6 rounded-2xl border border-gray-100 hover:border-yellow-300 hover:bg-yellow-50 transition-all duration-300 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${200 + i * 100}ms` }}
              >
                <div className="w-16 h-16 flex items-center justify-center bg-yellow-50 group-hover:bg-yellow-100 rounded-2xl transition-colors">
                  <img src={r.img} alt="" className="w-10 h-10 object-contain" />
                </div>
                <p className="text-sm font-medium text-gray-700 leading-snug">{r.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
